import { render } from "./SubCatProducts.vue?vue&type=template&id=4e7d1708"
import script from "./SubCatProducts.vue?vue&type=script&lang=js"
export * from "./SubCatProducts.vue?vue&type=script&lang=js"

import "./SubCatProducts.vue?vue&type=style&index=0&id=4e7d1708&lang=scss"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__